import {
  displayErrorToast,
  displaySucessToast,
} from "@endya-conformite/ui-kit";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

type ValidateCQVariables = {
  idCQ: string;
  siren: string;
  file?: File;
};

export const useValidateCQMutation = (idEntreprise: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ idCQ, siren, file }: ValidateCQVariables) => {
      await ControleQuinquennalApi.validate(idCQ, siren, file);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.detail(idEntreprise),
      });
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.lists(),
      });
      displaySucessToast(
        "Le contrôle quinquennal a bien été validé, vous pouvez fermer cette page."
      );
    },
    onError: (error) => {
      console.error("Error during CQ validation mutation", error);
      displayErrorToast(
        "Une erreur est survenue lors de la validation du contrôle quinquennal."
      );
    },
  });
};
